import { render, staticRenderFns } from "./FilePdf.vue?vue&type=template&id=649ce08c&scoped=true&"
import script from "./FilePdf.vue?vue&type=script&lang=js&"
export * from "./FilePdf.vue?vue&type=script&lang=js&"
import style0 from "./FilePdf.vue?vue&type=style&index=0&id=649ce08c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649ce08c",
  null
  
)

export default component.exports